import { NgClass, NgIf } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  signal,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { Subscription } from 'rxjs';
import { InputConfigInterface } from '@App/common/interfaces';
import { OtpInputComponent } from '@App/modules/pitch-card-shared/components';
import { VerificationResourceEnum } from '@App/common/enums';
import { UserCommonApiService } from '@App/common/services';
import { TranslateModule } from '@ngx-translate/core';
import { OtpInputComponent as OtpInputComponent_1 } from '../../../modules/pitch-card-shared/components/otp-input/otp-input.component';

@Component({
  selector: 'app-verify-form',
  styleUrls: ['./verify-form.component.scss'],
  templateUrl: './verify-form.component.html',
  standalone: true,
  imports: [OtpInputComponent_1, TranslateModule, NgIf, NgClass],
  encapsulation: ViewEncapsulation.None
})
export class VerifyFormComponent implements OnInit, OnChanges, OnDestroy {
  @Input() messageResource: string;
  @Input() errorMessage: string;
  @Input() confirmButtonClass =
    'button-simple shock-pink lg-50 uppercase margin-centered';

  @Output() otpCode = new EventEmitter<any>();
  @Output() resentOtp = new EventEmitter<any>();

  $formSubscriber = new Subscription();
  timer;
  resendOtpTimer;
  isTimerRunning: boolean;
  isResetTimerRunning = true;
  otp: string;
  verificationResources = VerificationResourceEnum;
  otpInputConfig: InputConfigInterface = {
    allowNumbersOnly: true,
    length: 4,
    isPasswordInput: false,
    placeholder: '',
    disableAutoFocus: false
  };

  @ViewChild(OtpInputComponent, { static: false })
  otpInput: OtpInputComponent;
  remainTime = signal(59);

  constructor(private userCommonService: UserCommonApiService) {}

  @HostListener('keydown.enter', ['$event'])
  onEnter(event: KeyboardEvent) {
    if (this.otp?.length === 4) {
      this.submitOtpCode(this.messageResource);
      const elmId: string = 'otp_0_' + this.otpInput.componentKey;
      if (elmId) {
        setTimeout(() => {
          this.otpInput.focusTo(elmId);
        }, 500);
      }
    }
  }

  ngOnInit() {
    this.setTimer();
    this.setResentOtpTimer();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.errorMessage?.currentValue) {
      this.otpInput.setValue('');
      this.otpInput.config.inputClass = 'bd-pink pink';
      this.errorMessage = changes.errorMessage.currentValue;
    }
  }

  ngOnDestroy() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    if (this.resendOtpTimer) {
      clearTimeout(this.resendOtpTimer);
    }
    if (this.$formSubscriber) {
      this.$formSubscriber.unsubscribe();
    }
  }

  onOtpChange(otp) {
    this.otp = otp;
    this.otpInput.config.inputClass = '';
    this.errorMessage = !otp && this.errorMessage ? this.errorMessage : '';
  }

  submitOtpCode(type) {
    if (this.otp) {
      this.otpCode.emit({
        otpCode: parseInt(this.otp, 10),
        type: type
      });
      this.isResetTimerRunning = true;
      this.setResentOtpTimer();
    }
  }

  resendOtpCode() {
    this.resentOtp.emit({ type: this.messageResource });
    this.setResentOtpTimer();
  }

  setResentOtpTimer() {
    this.isResetTimerRunning = true;
    this.startCountDown();
  }

  setTimer() {
    this.isTimerRunning = true;
    this.timer = setTimeout(() => {
      this.isTimerRunning = false;
    }, 600 * 1000);
  }

  openSupportWindow() {
    this.userCommonService.openSupportWindow(1);
  }

  private startCountDown() {
    const counter = setInterval(() => {
      this.remainTime.set(this.remainTime() - 1);
      if (this.remainTime() < 0) {
        clearInterval(counter);
        this.remainTime.set(59);
        this.isResetTimerRunning = false;
      }
    }, 1000);
  }
}
